import React from 'react';

import { DOCUMENT_TYPES } from '~constants/common';

import { useToast } from '~libs/toast';

import { AsyncActionIcon } from '~components';
import { faEnvelope, faFilePdf } from '~components/icon';
import { Row } from '~components/table-view-v3';
import { useDocumentBatchGeneration } from '~main/components/document-batch-jobs/useDocumentBatchGeneration';

interface ComponentProps {
  row?: Row;
}

const StatementActions: React.FC<ComponentProps> = ({ row }) => {
  const { generateSeparate, emailSeparate, isGenerating } = useDocumentBatchGeneration();
  const { showToast } = useToast();

  const handlePdf = async () => {
    if (!row?.id) return;
    try {
      await generateSeparate(DOCUMENT_TYPES.SAH_STATEMENT.SINGLE, [row.id as string]).unwrap();
      showToast('success', 'Statement generation started');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to start statement generation';
      showToast('danger', message);
      console.error('Statement PDF generation failed:', error);
      throw error;
    }
  };

  const handleEmail = async () => {
    if (!row?.id) return;
    try {
      await emailSeparate(DOCUMENT_TYPES.SAH_STATEMENT.SINGLE, [row.id as string]).unwrap();
      showToast('success', 'Statement email scheduled');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to schedule statement email';
      showToast('danger', message);
      console.error('Statement email scheduling failed:', error);
      throw error;
    }
  };

  return (
    <div className="d-flex align-items-center">
      <AsyncActionIcon
        id="generate-statement-pdf-icon"
        icon={faFilePdf}
        toolTip="Generate PDF"
        onClick={handlePdf}
        disabled={isGenerating}
        successTitle="Statement generation started"
        spinnerDataCy="statement-generate-spinner"
      />
      <AsyncActionIcon
        id="email-statement-icon"
        icon={faEnvelope}
        toolTip="Email Statement"
        onClick={handleEmail}
        disabled={isGenerating}
        successTitle="Statement email scheduled"
        spinnerDataCy="statement-email-spinner"
      />
    </div>
  );
};

export default StatementActions;
